import { ICliente } from './cliente.model';

export interface ISimulacion {
  id?: number;
  cantCuotas?: number | null;
  topeTasa?: number | null;
  objetoFinanciable?: string | null;
  sectorEconomico?: string | null;
  startUp?: boolean | null;
  actividadAgropecuaria?: string | null;
  categoriaAgricola?: string | null;
  categoriaEmpresa?: string | null;
  categoriaEmpresaCalculada?: string | null;
  periodicidad?: string | null;
  linea?: string | null;
  periodoGracia?: number | null;
  salarioMinimoVitalMovil?: number | null;
  tasaNominalAnualBNA?: number | null;
  montoSolicitado?: number | null;
  sinIva?: boolean | null;
  porcentajeInversion?: number | null;
  tasaNominalAnualFTyC?: number | null;
  cliente?: ICliente | null;
  interesCero?: boolean;
}

export class Simulacion implements ISimulacion {
  constructor(
    public id?: number,
    public objetoFinanciable?: string | null,
    public sectorEconomico?: string | null,
    public startUp?: boolean | null,
    public actividadAgropecuaria?: string | null,
    public categoriaAgricola?: string | null,
    public categoriaEmpresa?: string | null,
    public categoriaEmpresaCalculada?: string | null,
    public periodicidad?: string | null,
    public linea?: string | null,
    public periodoGracia?: number | null,
    public salarioMinimoVitalMovil?: number | null,
    public tasaNominalAnualBNA?: number | null,
    public montoSolicitado?: number | null,
    public sinIva?: boolean | null,
    public porcentajeInversion?: number | null,
    public tasaNominalAnualFTyC?: number | null,
    public cliente?: ICliente | null,
    public cantCuotas?: number | null,
    public topeTasa?: number | null,
    public interesCero?: boolean,
  ) {
    this.startUp = this.startUp = false;
  }
}
